// extracted by mini-css-extract-plugin
module.exports = {"definition":"definition__styles__definition--3HXsJHfA","label":"definition__styles__label--2RR3LN6y","children":"definition__styles__children--25EWisk1"};